"use client";

import type { AboutData } from "@/services/public.service";

function Icon({ name, className = "", fill = false }: { name: string; className?: string; fill?: boolean }) {
  return <span className={`material-symbols-outlined ${fill ? "fill" : ""} ${className}`}>{name}</span>;
}

export default function AboutVisionMission({ about, isAr }: { about: AboutData; isAr: boolean }) {
  const t = (a: string, e: string) => (isAr ? a : e);
  const vision = about.vision ? (isAr ? about.vision.ar : about.vision.en) : "";
  const mission = about.mission ? (isAr ? about.mission.ar : about.mission.en) : "";
  if (!vision && !mission) return null;

  const cards = [
    { show: !!vision, icon: "visibility", title: t("رؤيتنا", "Our vision"), body: vision },
    { show: !!mission, icon: "flag", title: t("رسالتنا", "Our mission"), body: mission },
  ].filter((c) => c.show);

  return (
    <section className="bg-clay-50 najdi-pattern py-16 md:py-20">
      <div className="container mx-auto px-6 grid md:grid-cols-2 gap-6">
        {cards.map((c) => (
          <div key={c.icon} className="rounded-3xl border border-clay-100 bg-surface p-8">
            <div className="w-14 h-14 rounded-2xl bg-clay-600 text-white flex items-center justify-center mb-5">
              <Icon name={c.icon} fill className="text-2xl" />
            </div>
            <h3 className="font-display text-2xl font-bold text-ink-900 mb-3">{c.title}</h3>
            {/* Written with the dashboard's rich editor → HTML (sanitized server-side). */}
            <div
              className="text-ink-500 leading-loose [&_a]:text-clay-600 [&_a]:underline [&_li]:ms-5 [&_ol]:list-decimal [&_p+p]:mt-3 [&_strong]:text-ink-900 [&_ul]:list-disc"
              dangerouslySetInnerHTML={{ __html: c.body }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
